import { ReactElement, PropsWithChildren } from 'react';

import Icon from '../../../components/Icon';

import './styles.scss';

interface AccessScopeSectionProps {
  icon: string;
}

export default function AccessScopeSection(props: PropsWithChildren<AccessScopeSectionProps>): ReactElement {
  const { icon, children } = props;

  return (
    <div className="access-scope-section">
      <Icon icon={icon} width="24" height="24" />
      <div className="access-scope-section__content">{children}</div>
    </div>
  );
}
